import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { HeartIcon, MenuIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
const links = [{
  to: '/',
  label: 'Accueil'
}, {
  to: '/boutique?cat=laine',
  label: 'Pelotes de laine'
}, {
  to: '/boutique?cat=crochet',
  label: 'Créations au crochet'
}, {
  to: '/boutique?cat=mercerie',
  label: 'Mercerie'
}, {
  to: '/boutique?cat=puzzle',
  label: 'Puzzles'
}, {
  to: '/contact',
  label: 'La boutique'
}];
export function Header() {
  const {
    count,
    openCart
  } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const current = location.pathname + location.search;
  return <header className="sticky top-0 z-40 border-b border-encre/10 bg-creme/95 backdrop-blur" data-id="element-96" data-mp="36d4nivcbh8tu">
      <div className="bg-encre text-creme" data-id="element-97" data-mp="3bbzfonw6c9qm">
        <p className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-2 text-center text-xs font-medium sm:text-sm" data-id="element-98" data-mp="3fb88nqje43l4">
          <HeartIcon className="h-3.5 w-3.5 fill-framboise text-framboise" aria-hidden="true" data-id="element-99" data-mp="2wlmc5o5ukmon" />
          Retrait gratuit au 58 rue Chanzy, Vouziers — livraison offerte dès 49 €
        </p>
      </div>

      <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 py-4 sm:px-6" data-id="element-100" data-mp="2mn6sg695gfp6">
        <Link to="/" className="flex shrink-0 flex-col leading-none" data-id="element-101" data-mp="2hon4y1ewqvup">
          <span className="font-display text-2xl font-extrabold tracking-tight text-encre sm:text-[28px]" data-id="element-102" data-mp="3fb2k2wjv3hf3">
            Meli Melo <span className="text-framboise" data-id="element-103" data-mp="3abzjboawzxcx">Services</span>
          </span>
          <span className="mt-0.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-encre-light" data-id="element-104" data-mp="35l9dk9yktshp">
            Laine · Mercerie · Loisirs créatifs
          </span>
        </Link>

        <nav aria-label="Navigation principale" className="ml-auto hidden lg:block" data-id="element-105" data-mp="1wfpoo6c0cxc">
          <ul className="flex items-center gap-1" data-id="element-106" data-mp="1yadca8zmj54">
            {links.map(link => <li key={link.label} data-id="element-107" data-mp="3t90n55sqfrfa">
                <NavLink to={link.to} className={() => ['rounded-full px-3.5 py-2 text-sm font-semibold transition-colors duration-150 ease-out', current === link.to ? 'bg-framboise-soft text-framboise-dark' : 'text-encre hover:bg-creme-deep'].join(' ')} data-id="element-108" data-mp="1rdtcpxw2m35f">
                  {link.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="ml-auto flex items-center gap-2 lg:ml-0" data-id="element-109" data-mp="1cmc8nsged4ez">
          <button type="button" onClick={openCart} className="relative flex items-center gap-2 rounded-full bg-framboise px-4 py-2.5 text-sm font-bold text-white transition-colors duration-150 ease-out hover:bg-framboise-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-encre focus-visible:ring-offset-2 focus-visible:ring-offset-creme" data-id="element-110" data-mp="yqgtnxp4cdgv">
            <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="mf6dgy27rg96" />
            <span className="hidden sm:inline" data-id="element-112" data-mp="hgmn8lgl7ib0">Panier</span>
            <span className="grid h-5 min-w-[20px] place-items-center rounded-full bg-white px-1 text-xs font-extrabold text-framboise" aria-label={`${count} article${count > 1 ? 's' : ''} dans le panier`} data-id="element-113" data-mp="w4hgc2yiboom">
              {count}
            </span>
          </button>

          <button type="button" onClick={() => setMobileOpen(o => !o)} className="grid h-10 w-10 place-items-center rounded-full border border-encre/15 text-encre lg:hidden" aria-expanded={mobileOpen} aria-label="Ouvrir le menu" data-id="element-114" data-mp="106bf25p56im5">
            {mobileOpen ? <XIcon className="h-5 w-5" data-id="element-115" data-mp="3gu6x4lirtkjy" /> : <MenuIcon className="h-5 w-5" data-id="element-116" data-mp="3gv8ibiti3nfe" />}
          </button>
        </div>
      </div>

      {mobileOpen && <nav aria-label="Navigation mobile" className="border-t border-encre/10 bg-creme lg:hidden" data-id="element-117" data-mp="3bxgdjo7rc6ts">
          <ul className="mx-auto max-w-7xl px-4 py-2 sm:px-6" data-id="element-118" data-mp="22yf6xpptti0z">
            {links.map(link => <li key={link.label} data-id="element-119" data-mp="27zuvvsv4k8on">
                <Link to={link.to} onClick={() => setMobileOpen(false)} className="block border-b border-encre/5 py-3 text-sm font-semibold text-encre last:border-0" data-id="element-120" data-mp="2cx4kj6aowgbf">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </nav>}
    </header>;
}